import React, { useState, useEffect, useRef } from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import { NachFilterReducerAction } from "../Store/NachFilterReducer";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import "./NachExtraction.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import store from "../Store";
const NachExtraction = () => {
  const FilteredData = useSelector((state) => state.nachFilter.data);
  const [draweeBank, setDraweeBank] = useState("");
  const [draweeBankHasError, setDraweeBankHasError] = useState(false);
  const [draweeBankList, setDraweeBankList] = useState([]);
  const [dueValidDateFromError, setDueValidDateFromError] = useState(false);
  const [dueValidDateToError, setDueValidDateToError] = useState(false);
  const [repaymentValue, setRepaymentValue] = useState("NACH");
  const [validStartDate, setValidStartDate] = useState("");
  const [validEndDate, setValidEndDate] = useState("");
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [verifiedFromDateEnable, setVerifiedFromDateEnable] = useState(false);
  const [verifiedToDateEnable, setVerifiedToDateEnable] = useState(false);
  const userNames = useSelector((state) => state.branch.userName);
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  const dispatch = useDispatch();
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };
  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  let minDateToValue = Number(0);
  let maxDateToValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Nach Extraction From Request Date Back Count"] &&
        new Date(
          paramValues["Nach Extraction From Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Extraction From Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        // Temp Fix For live issue -> unable to add field special access i.e 24/10/2024.

        // fieldAccessMap.nachExtractionFromDate &&
        // fieldAccessMap.nachExtractionFromBackCount
        // ?
        Number(
          paramValues["Nach Extraction From Request Date Back Count"][
            "paramValue"
          ]
        );
      // : Number(0);
    }
    if (
      !(
        paramValues["Nach Extraction From Request Date Future Count"] &&
        new Date(
          paramValues["Nach Extraction From Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Extraction From Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        // Temp Fix For live issue -> unable to add field special access i.e 24/10/2024.

        // fieldAccessMap.nachExtractionFromDate &&
        // fieldAccessMap.nachExtractionFromFutureCount
        // ?
        Number(
          paramValues["Nach Extraction From Request Date Future Count"][
            "paramValue"
          ]
        );
      // : Number(0);
    }
    if (
      !(
        paramValues["Nach Extraction To Request Date Back Count"] &&
        new Date(
          paramValues["Nach Extraction To Request Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Extraction To Request Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateToValue = 0;
    } else {
      minDateToValue =
        // Temp Fix For live issue -> unable to add field special access i.e 24/10/2024.

        // fieldAccessMap.nachExtractionToDate &&
        // fieldAccessMap.nachExtractionToBackCount
        // ?
        Number(
          paramValues["Nach Extraction To Request Date Back Count"][
            "paramValue"
          ]
        );
      // : Number(0);
    }
    if (
      !(
        paramValues["Nach Extraction To Request Date Future Count"] &&
        new Date(
          paramValues["Nach Extraction To Request Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Nach Extraction To Request Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateToValue = 0;
    } else {
      maxDateToValue =
        // Temp Fix For live issue -> unable to add field special access i.e 24/10/2024.

        // fieldAccessMap.nachExtractionToDate &&
        // fieldAccessMap.nachExtractionToFutureCount
        // ?
        Number(
          paramValues["Nach Extraction To Request Date Future Count"][
            "paramValue"
          ]
        );
      // : Number(0);
    }
  }

  useEffect(() => {
    /*  const branchValues = GetBranchDetails();
    setBranchArray(branchValues); */
    getNachSponserBankDetails();
  }, []);

  //shortcut key
  const downloadRef = useRef(null);
  useEffect(() => {
    //dueDate !== "" && setDeactivationDateValue(dueDate);
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [verifiedFromDateEnable, verifiedToDateEnable]);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachExtraction",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = { downloadRef: downloadRef };
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        verifiedFromDateEnable && setValidStartDate(date);
        verifiedToDateEnable && setValidEndDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        verifiedFromDateEnable && setValidStartDate(date);
        verifiedToDateEnable && setValidEndDate(date);
      } else if (charCode === "i") {
        date = new Date();
        verifiedFromDateEnable && setValidStartDate(date);
        verifiedToDateEnable && setValidEndDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "nachExtraction",
          })
        );
      }
    }
  };
  const getNachSponserBankDetails = async () => {
    try {
      // const response = await axios.post(
      //   "https://bmapp.sundaramhome.in/stlms/ostlap/sblov",
      //   {}
      // );
      const response = await axios.post("/api/getSponserBankFromlos", {
        apiCode: "SPONSOR_BANK_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      });

      const sponserBanks = response.data.sponsor_bank_dtls;
      setDraweeBankList(sponserBanks);
    } catch {}
  };
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  const handleDownload = () => {
    const draweeBankValid =
      draweeBank !== "" && draweeBank !== null && draweeBank !== undefined;
    const validStartDateValid =
      validStartDate !== "" &&
      validStartDate !== undefined &&
      validStartDate !== null &&
      !dueValidDateFromError;
    const validEndDateDateValid =
      validEndDate !== "" &&
      validEndDate !== undefined &&
      validEndDate !== null &&
      !dueValidDateToError;
    if (draweeBankValid && validStartDateValid && validEndDateDateValid) {
      try {
        // get the sponser bank code.
        const sponserBank = draweeBankList.filter(
          (sponserBank) => sponserBank.bank_name === draweeBank
        );
        axios
          .post(
            "/nachExclude/downloadExcelForExtract",

            {
              userName: userNames,
              repayMode: repaymentValue,
              sponsorBank: draweeBank,
              sponsorBankCode: sponserBank[0]?.bank_code,
              startDate: validStartDate.toLocaleDateString("en-ZA"),
              endDate: validEndDate.toLocaleDateString("en-ZA"),
            },
            {
              method: "POST",
              responseType: "blob",
            }
          )
          .then((response) => {
            let date = `${new Date().getFullYear()}-${
              new Date().getMonth() + 1 > 9
                ? new Date().getMonth() + 1
                : "0" + new Date().getMonth() + 1
            }-${
              new Date().getDate() > 9
                ? new Date().getDate()
                : "0" + new Date().getDate()
            }`;
            const fileName = "Nach_mandate_".concat(date).concat(".xlsx");
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setMessage("Nach Extraction Downloaded Success.");
            setAlertType("success");
            openAlertHandler();
            /*  if (response.status === 200) {
            setSuccessDialogOpen(true);
          } */
          });
      } catch (error) {
        throw Error(error);
      }
    } else {
      // for empty values on direct download btn click.
      setDraweeBankHasError(!draweeBankValid);
      setDueValidDateFromError(!validStartDateValid);
      setDueValidDateToError(!dueValidDateToError);
    }
  };
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord-nach-exclude"
          title="Mandate Registration"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Grid container>
            <Grid
              className="repayment-mode"
              xs={12}
              sm={6}
              md={6}
              lg={3}
              xl={3}
            >
              <CustomTextField
                type="text"
                label="Repay Mode"
                variant="standard"
                placeholder="Repay Mode"
                value={repaymentValue}
                disabled={true}
              />
            </Grid>
            <Grid
              className="repayment-mode"
              xs={12}
              sm={6}
              md={6}
              lg={3}
              xl={3}
            >
              <CustomAutoComplete
                label="Sponsor Bank"
                id="sponsor-bank"
                variant="standard"
                disabled={false}
                required={true}
                value={draweeBank}
                onChange={(event, newValue) => {
                  setDraweeBank(newValue);
                  setDraweeBankHasError(
                    newValue !== null &&
                      newValue !== "" &&
                      newValue !== undefined
                      ? false
                      : true
                  );
                }}
                type="text"
                placeholder="Sponsor Bank"
                autoCompleteValues={draweeBankList.map(
                  (sponserBank) => sponserBank.bank_name
                )}
              />
              {draweeBankHasError && (
                <p className="error">Please Select Sponsor Bank</p>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={3}
              className="repayment-mode"
            >
              <CustomDateField
                disabled={false}
                required={true}
                label="Verified From Date"
                id="verifiedFromDate"
                variant="standard"
                value={validStartDate}
                type="text"
                minDate={new Date().setDate(
                  new Date().getDate() - minDateFromValue
                )}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateFromValue
                )}
                onChange={(event) => {
                  setValidStartDate(event ? new Date(event) : null);

                  const newDateValue = `${new Date(event).getFullYear()}/${
                    new Date(event).getMonth() + 1 > 9
                      ? new Date(event).getMonth() + 1
                      : "0" + new Date(event).getMonth() + 1
                  }/${
                    new Date(event).getDate() > 9
                      ? new Date(event).getDate()
                      : "0" + new Date(event).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateFromValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateFromValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setDueValidDateFromError(false)
                    : setDueValidDateFromError(true);
                }}
                onBlur={(event) => {
                  setValidStartDate(event ? new Date(event) : null);

                  const newDateValue = `${new Date(event).getFullYear()}/${
                    new Date(event).getMonth() + 1 > 9
                      ? new Date(event).getMonth() + 1
                      : "0" + new Date(event).getMonth() + 1
                  }/${
                    new Date(event).getDate() > 9
                      ? new Date(event).getDate()
                      : "0" + new Date(event).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateFromValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateFromValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setDueValidDateFromError(false)
                    : setDueValidDateFromError(true);
                }}
                onOpen={() => {
                  setVerifiedFromDateEnable(true);
                  setVerifiedToDateEnable(false);
                }}
              />
              {dueValidDateFromError && (
                <p className="error">Please Enter Valid Date</p>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={3}
              className="repayment-mode"
            >
              <CustomDateField
                disabled={false}
                required={true}
                label="Verified To Date"
                id="verifiedToDate"
                variant="standard"
                value={validEndDate}
                type="text"
                minDate={new Date().setDate(
                  new Date().getDate() - minDateToValue
                )}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateToValue
                )}
                onChange={(event) => {
                  setValidEndDate(event ? new Date(event) : null);

                  const newDateValue = `${new Date(event).getFullYear()}/${
                    new Date(event).getMonth() + 1 > 9
                      ? new Date(event).getMonth() + 1
                      : "0" + new Date(event).getMonth() + 1
                  }/${
                    new Date(event).getDate() > 9
                      ? new Date(event).getDate()
                      : "0" + new Date(event).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateToValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateToValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setDueValidDateToError(false)
                    : setDueValidDateToError(true);
                }}
                onBlur={(event) => {
                  setValidEndDate(event ? new Date(event) : null);

                  const newDateValue = `${new Date(event).getFullYear()}/${
                    new Date(event).getMonth() + 1 > 9
                      ? new Date(event).getMonth() + 1
                      : "0" + new Date(event).getMonth() + 1
                  }/${
                    new Date(event).getDate() > 9
                      ? new Date(event).getDate()
                      : "0" + new Date(event).getDate()
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateToValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + new Date(maxValue).getMonth() + 1
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + new Date(maxValue).getDate()
                  }`;

                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateToValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + new Date(minValue).getMonth() + 1
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + new Date(minValue).getDate()
                  }`;
                  const specialAccessMaxFlag = newDateValue <= maxDateValue;
                  const specialAccessMinFlag = newDateValue >= minDateValue;
                  specialAccessMaxFlag && specialAccessMinFlag
                    ? setDueValidDateToError(false)
                    : setDueValidDateToError(true);
                }}
                onOpen={() => {
                  setVerifiedFromDateEnable(false);
                  setVerifiedToDateEnable(true);
                }}
              />
              {dueValidDateToError && (
                <p className="error">Please Enter Valid Date</p>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={0} columnSpacing={2}></Grid>
          <Box
            sx={{
              marginTop: "8px",
              display: "flex",
              marginBottom: "4px",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+J" placement="top">
              <Button
                variant="contained"
                component="label"
                onClick={handleDownload}
                ref={downloadRef}
                sx={{ height: "2rem", fontWeight: "bold" }}
              >
                Download
              </Button>
            </Tooltip>
          </Box>
        </AccordianContainer>
      </Box>
      <CustomConfirmationDialog
        dialogOpen={successDialogOpen}
        dialogTitle={
          <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
        }
        dialogContent={
          <>
            <Typography sx={{ fontSize: "1rem" }}>
              File Downloaded Successfully.
            </Typography>
          </>
        }
        hideCancelButton={true}
        okButtonName={"OK"}
        cancelButtonName={""}
        onOkClick={() => window.location.reload()}
      />
      <Snackbar
        open={alert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
export default NachExtraction;
